import React from 'react';
import * as S from './PricingTableCell.styled';
export const PricingTableCell = ({ mainContent, additionalContent }) => (React.createElement(S.Container, null,
    React.createElement(S.ContentContainer, null,
        React.createElement(S.MainContent, null, mainContent),
        additionalContent && React.createElement(S.AdditionalContent, null, additionalContent))));
